import { style, trigger, state, animate, transition } from '@angular/animations';
import { Component, AfterViewInit, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { IntersectionObserverService } from 'src/app/intersection-observer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-social-media-plans',
  templateUrl: './social-media-plans.component.html',
  styleUrls: ['./social-media-plans.component.css'],
  animations: [
    trigger('flipAnimation', [
      state('initial', style({ transform: 'rotateY(0)' })),
      state('flipped', style({ transform: 'rotateY(360deg)' })),
      transition('initial => flipped', [
        animate('0.6s ease-in-out')
      ])
    ]),
  ]

})
export class SocialMediaPlansComponent implements AfterViewInit, OnInit {
  constructor(private elementRef: ElementRef, private intersectionObserverService: IntersectionObserverService, private renderer: Renderer2,public router: Router,) { }
  currentSlide = 0;
  ismonthly: boolean = true;
  isannually: boolean = false;
  state = 'small';
  startanimation: boolean = false;
  currentState = 'initial';

  toggleFlip() {
    this.currentState = this.currentState === 'initial' ? 'flipped' : 'initial';
  }
  toggleFlip2() {
    this.currentState = this.currentState === 'flipped' ? 'initial' : 'flipped';
  }
  ngOnInit(): void {
    this.intersectionObserverService.observe(this.elementRef.nativeElement);
  }

  monthly(): void {
    this.toggleFlip2();
    this.ismonthly = true;
    this.isannually = false;

  }

  annually(): void {
    this.ismonthly = false;
    this.isannually = true;
    this.toggleFlip();
  }
  GetStarted(){
    this.router.navigate(["/Login"]);
    
  }
  ngAfterViewInit(): void {
    // const countelements = this.elementRef.nativeElement.querySelectorAll('.social_box');
    const elements = this.elementRef.nativeElement.querySelectorAll('.social_media_card_1, .social_media_card_2, .social_media_card_3');
    const slidesContainer = document.querySelector('.social_media_sliders') as HTMLElement;
    slidesContainer.addEventListener('scroll', this.onScroll.bind(this));
    elements.forEach((element: HTMLElement) => {
      this.intersectionObserverService.observe(element);
    });
  }

  setSlide(index: number): void {
    const slidesContainer = document.querySelector('.social_media_sliders') as HTMLElement;
    const slideWidth = slidesContainer.scrollWidth / slidesContainer.childElementCount;
    slidesContainer.scrollTo({
      left: index * slideWidth,
      behavior: 'smooth'
    });
    this.currentSlide = index;
  }

  onScroll(event: Event): void {
    const slidesContainer = event.target as HTMLElement;
    const slideWidth = slidesContainer.scrollWidth / slidesContainer.childElementCount;
    const scrollPosition = slidesContainer.scrollLeft;
    this.currentSlide = Math.round(scrollPosition / slideWidth);
  }
}
